
    //import DatePicker from 'v-calendar/lib/components/date-picker.umd';    
    import moment from 'moment';
    import VCalendar from 'v-calendar';
    import Vue from 'vue';

    export interface Range {
        key: string;
        title: string;
        start: any;
        end: any;
    }

    export default Vue.extend({
        name: 'DatePickerCalendar',
        model: {
            prop: 'selectedDate'
        },
        components: {
            'v-date-picker': VCalendar.DatePicker,
        },
        props: {
            tag: {
                type: String,
                default: 'li'
            },
            isSingleDate: {
                type: Boolean,
                default: false
            },
            singleDateTitleShortFormat: {
                type: Boolean,
                default: false
            },
            singleDateShowIncrementArrows: {
                type: Boolean,
                default: false
            },
            showDropDownArrow: {
                type: Boolean,
                default: true
            },
            rangesToShow: {
                type: String,
                default: ""
            }
        },
        data() { 
            return {
                isOpen: false,
                dateFormatDisplayString: 'MMM DD, YYYY',
                dateFormatYYYYMMDD: 'YYYYMMDD',
                // Data used by the date picker
                selectedDate: {
                    start: moment().subtract(29, 'days').toDate() as Date|null,
                    end: moment().endOf('day').toDate() as Date|null,
                    date: new Date(),
                    displayTitle: ""
                },
                selectedTitle: "",
                selectedKey: "",
                allRanges: {
                    'future': {
                                    key: 'future',
                                    title: 'Future',
                                    start: moment().startOf('day'),
                                    end: moment('20991231', 'YYYYMMDD').toDate()
                                },
                    'next12Months': {
                                    key: 'next12Months',
                                    title: 'Next 12 Months',
                                    start: moment().startOf('day'),
                                    end: moment().add(12, 'month')
                                },
                    'next90Days': {
                                    key: 'next90Days',
                                    title: 'Next 90 Days',
                                    start: moment().startOf('day'),
                                    end: moment().add(90, 'days')
                                },
                    'next30Days': {
                                    key: 'next30Days',
                                    title: 'Next 30 Days',
                                    start: moment().startOf('day'),
                                    end: moment().add(30, 'days')
                                },
                    'next7Days': {
                                    key: 'next7Days',
                                    title: 'Next 7 Days',
                                    start: moment().startOf('day'),
                                    end: moment().add(7, 'days')
                                },
                    'last7Days': {
                                    key: 'last7Days',
                                    title: 'Last 7 Days',
                                    start: moment().subtract(6, 'days'),
                                    end: moment().endOf('day')
                                },
                    'last30Days': {
                                    key: 'last30Days',
                                    title: 'Last 30 Days',
                                    start: moment().subtract(29, 'days'),
                                    end: moment().endOf('day')
                                },
                    'last90Days': {
                                    key: 'last90Days',
                                    title: 'Last 90 Days',
                                    start: moment().subtract(89, 'days'),
                                    end: moment().endOf('day')
                                },
                    'past': {
                                    key: 'past',
                                    title: 'Past',
                                    start: moment('20180101', 'YYYYMMDD').toDate(),
                                    end: moment().endOf('day')
                                },
                    'thisMonth': {
                                    key: 'thisMonth',
                                    title: 'This Month',
                                    start: moment().startOf("month"),
                                    end: moment().endOf("month")
                                },
                    'nextMonth': {
                                    key: 'nextMonth',
                                    title: 'Next Month',
                                    start: moment().add(1, 'months').startOf("month"),
                                    end: moment().add(1, 'months').endOf("month")
                                },
                    'lastMonth': {
                                    key: 'lastMonth',
                                    title: 'Last Month',
                                    start: moment().subtract(1, 'months').startOf("month"),
                                    end: moment().subtract(1, 'months').endOf("month")
                                },
                    'thisCalendarYear': {
                                    key: 'thisCalendarYear',
                                    title: 'This Calendar Year',
                                    start: moment().startOf("year"),
                                    end: moment().endOf("year")
                                },
                    'nextCalendarYear': {
                                    key: 'nextCalendarYear',
                                    title: 'Next Calendar Year',
                                    start: moment().add(1, 'years').startOf("year"),
                                    end: moment().add(1, 'years').endOf("year")
                                },
                    'lastCalendarYear': {
                                    key: 'lastCalendarYear',
                                    title: 'Last Calendar Year',
                                    start: moment().subtract(1, 'years').startOf("year"),
                                    end: moment().subtract(1, 'years').endOf("year")
                                },
                    'all': {
                                    key: 'all',
                                    title: 'All',
                                    start: moment('20180101', 'YYYYMMDD').toDate(),
                                    end: null
                                }
                },
                ranges: [] as Range[],
                attrs: [
                    {
                        // highlight style
                        highlight: {
                            color: 'purple',
                            fillMode: 'light',
                        }
                    },
                    {
                        // a dot for the current day
                        dot: {
                            backgroundColor: '#4e9a3c',
                        },
                        dates: [
                            moment().toDate()
                        ],
                    }
                ]
            }
        },
        computed: {
            title(): string {
                if (this.isSingleDate) {
                    // display the signle date selected
                    if (this.singleDateTitleShortFormat) {
                        return moment(this.selectedDate.date).format(this.dateFormatDisplayString);
                    }
                    else {
                        return moment(this.selectedDate.date, "YYYY-MM-DD").format('dddd DD MMMM, YYYY');
                    }
                }
                else {
                    // display the range title or the date range if manually selected in the calendar control
                    return this.selectedTitle.length > 0
                        ? this.selectedTitle
                        : moment(this.selectedDate.start).format(this.dateFormatDisplayString) + ' - ' + moment(this.selectedDate.end).format(this.dateFormatDisplayString);
                    }
            },
            showNarrow(): boolean {
                // return true if we need to display only the calendar component
                return this.isSingleDate || this.ranges.length == 0;
            }
        },
        methods: {
            toggleDropDown() {
                this.isOpen = !this.isOpen;
            },
            openDropDown() {
                this.isOpen = true;
            },
            closeDropDown(event) {
                if(!event.currentTarget.contains(event.relatedTarget)) { 
                    this.isOpen = false;
                }
            },
            inputDateSelected(value) {
                this.selectedDate.date = new Date(value);
                this.selectedKey = "";
                this.$emit('change', this.selectedDate);                 
            },
            rangeDragged(range) {
                // the user has selected a range by dragging
                this.selectedDate.start = new Date(range.start);
                this.selectedDate.end = new Date(range.end);  
                this.selectedTitle = "";
                this.selectedKey = "";

                this.selectedDate.displayTitle = "Custom";
                this.$emit('change', this.selectedDate);
            },
            clickRange(value) {
                // assing the values
                // check the end date is not 01/01/1970 (revert this to null)
                if (!value.end) {
                    this.selectedDate.end = null; 
                }
                else this.selectedDate.end = new Date(value.end); 

                this.selectedDate.start = new Date(value.start);                 
                this.selectedDate.displayTitle = value.title.toString();
                this.selectedKey = value.key;

                // pass to parent
                this.$emit('change', this.selectedDate);  

                // set local
                this.selectedTitle = value.title.toString();
                this.refreshCalendar();   

                // prevent the event from propgating
                return false;
            },
            progressSelectedDay(days: number) {
                this.selectedDate.date = moment(this.selectedDate.date).add(days, 'days').toDate();
                this.selectedKey = "";
                //this.$emit('change', this.selectedDate);  
                this.refreshCalendarForDate(); 
            },
            refreshCalendar() {
                if (this.$refs && this.$refs.picker) {
                    const pickerElement = (this.$refs.picker as VCalendar.DatePicker);
                    pickerElement?.updateValue(this.selectedDate);
                    pickerElement?.adjustPageRange();
                }
            },
            refreshCalendarForDate() {
                if (this.$refs && this.$refs.picker) {
                    const pickerElement = (this.$refs.picker as VCalendar.DatePicker);
                    pickerElement?.updateValue(this.selectedDate.date);
                }
            },
            selectRanges() {
                // select the ranges using the keys provided
                if (this.rangesToShow.length > 0) {
                    // go through the provided keys and show them in the calendar
                    const rangesToShowArray = this.rangesToShow.split(',');
                    rangesToShowArray.forEach(key => {
                        if (this.allRanges[key]) this.ranges.push(this.allRanges[key]);
                    });
                }
                //console.log(this.ranges);
            }
        },
        mounted() {
            // pre-select a default date range
            this.selectRanges();
            if (this.ranges.length > 0) this.clickRange(this.ranges[0]);
        }
    });
